import { render } from "./AddPreferredShippingMethod.vue?vue&type=template&id=2cbd5ecc"
import script from "./AddPreferredShippingMethod.vue?vue&type=script&lang=js"
export * from "./AddPreferredShippingMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__